/* eslint import/prefer-default-export: 0 */

/**
 * [fileToDataUrl]
 * @param  {File} file
 * @return {Promise} [sends back the dataUrl in the resolve]
 */
export function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    if (!file) {
      resolve(null);
    }

    const reader = new window.FileReader();
    reader.addEventListener('load', () => {
      resolve(reader.result);
    });
    reader.addEventListener('error', () => {
      reject(reader.error);
    });
    reader.readAsDataURL(file);
  });
}

export function fileToText(file) {
  return new Promise((resolve, reject) => {
    if (!file) {
      resolve(null);
    }

    const reader = new window.FileReader();
    reader.addEventListener('load', () => {
      resolve(reader.result);
    });
    reader.addEventListener('error', () => {
      reject(reader.error);
    });
    reader.readAsText(file);
  });
}
